import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { TaxonomyPageName, CONSTANTS, PageName } from '@app/constants';
import { TaxonomyTermPages, DefaultIndexDoc } from '@app/graphql';
import { DataService, PagesService, PageService } from '@app/data';

@Component({
  selector: 'app-schools',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './schools.component.html',
  styleUrls: ['./schools.component.less']
})
export class SchoolsComponent implements OnDestroy {

  public currentTaxonomyPage$ = this.data.currentTaxonomyPage$;

  public items$: Observable<any> = this.page.getTaxonomyPages$(this.taxonomyPageName);

  public pageName: string = this.data.getCurrentPageName();

  constructor(
      private data: DataService,
      private route: ActivatedRoute,
      private pages: PagesService,
      private page: PageService
  ) {
    //this.currentTaxonomyPage$.subscribe((data:any) => console.log('SchoolsComponent currentTaxonomyPage$ data ', data));
    //this.items$.subscribe((data:any) => console.log('SchoolsComponent items$ data ', data));
  }

  ngOnDestroy(): void {
    //console.log('SearchComponent ngOnDestroy');

    //this.data.saveScrollPosition(this.pageName);    
  }

  get taxonomyPageName(): string {

    return this.data.getTaxonomyPageName();
  }

  public getClass = (): string => this.data.getClass();

}
